// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottom-actions{position:fixed;bottom:0px;width:100%;display:flex;right:0;height:70px;background-color:#fff;z-index:100;box-shadow:0px -1px 2px 2px #e2e2e2}\n", ""]);
// Exports
module.exports = exports;
